var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav"},[_c('LinkList',{attrs:{"links":_vm.mainNavigationItems,"align":_vm.align,"orientation":_vm.orientation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }